import React from 'react';
import { Link } from 'react-router-dom/dist';

const Tag = ({ tag }) => {
  return (
    <div className="">
      <Link
        to="#"
        className="px-6 pb-[1.5px] text-[10px] sm:text-h4 bg-primary-0 rounded-xl  border-primary-5 border-solid border-2"
      >
        {tag}
      </Link>
    </div>
  );
};

export default Tag;
